import React, { Component } from 'react';
import MenuDropdown from '../../portal/controls/menuDropdown';

export default class AuthenticationProvidersDropown extends Component {

    render() {
        
        const { list, select, value } = this.props;

        return (
            <div
                className='login-prviders-dropdown-wrapper'
                data-cy='login-prviders-menu'
            >
                <MenuDropdown 
                    onItemClick={select}
                    data={list} 
                    value={value}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/account/authenticationProvidersDropown/dropDown.jsx